/**
  ---DO NOT EDIT THIS FILE DIRECTLY---
  This CSS file was concatenated from files listed in the css/ folder as part of a build process
  This is to allow for js import with @import links which will not be followed
**/

/* src/primitives/rail/css/definition/content/rail.css */
@layer rail.definition.content.rail;

/* src/primitives/rail/css/definition/variations/aligned.css */
@layer rail.definition.variations.aligned;

/* src/primitives/rail/css/definition/rail-definition.css */

/* src/primitives/rail/css/theme/content/rail-variables.css */
@layer rail.theme.content.rail {
  :host {
  }
}

/* src/primitives/rail/css/theme/variations/aligned-variables.css */
@layer rail.theme.variations.aligned {
  :host {
  }
}

/* src/primitives/rail/css/theme/rail-theme.css */

/* src/primitives/rail/css/rail.css */
